import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/team.module.scss';

/**
 * Single role row inside Role Permissions.
 *
 * @param {Object} props
 * @param {string} props.role
 * @param {string} props.scope
 * @param {string} props.description
 * @returns {React.ReactNode}
 */
function RolePermissionsCardItem({ role, scope, description }) {
    return (
        <div className={styles.permissionItem}>
            <div className={styles.permissionHeading}>
                <Text as="span" size="s" className={styles.permissionRole}>
                    {role}
                </Text>
                <Text as="span" size="xs" className={styles.permissionScope}>
                    — {scope}
                </Text>
            </div>
            <Text as="p" size="xs" className={styles.permissionDescription}>
                {description}
            </Text>
        </div>
    );
}

export default RolePermissionsCardItem;
